import { MentionMeSituation } from './mention-me-situation.enum';

export interface MentionMeDomainConfig {
  situation?: MentionMeSituation;
  referrerOffer?: string;
}
